import { render, staticRenderFns } from "./AuthConfirmEmail.vue?vue&type=template&id=08c49cb5"
import script from "./AuthConfirmEmail.vue?vue&type=script&lang=js"
export * from "./AuthConfirmEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports